<template>
    <div class="page">
        <Navigation pageName="auditLogs" />
        <!--FILTRI E RICERCA-->
        <div class="filter-section">
            <div class="filter-left">
                <label class="text-bold">{{ $t("User") }}</label>
                <select class="select text-small" v-model="filters.user">
                    <option value="">{{ $t("All users") }}</option>
                    <option v-for="user in users" :key="user.id" :value="user.id"> {{ $t(user.username) }}</option>
                </select>
            </div>
            <div class="filter-left">
                <label class="text-bold">{{ $t("Category") }}</label>
                <select class="select text-small" v-model="filters.category">
                    <option value="">{{ $t("All categories") }}</option>
                    <option v-for="category in categories" :key="category.id" :value="category.id"> {{ $t(category.description) }}</option>
                </select>
            </div>
            <div class="filter-left">
                <!--<select class="select text-small w-auto px-2 ml-2 mb-2" v-model="filters.id_activity">
                    <option value="">{{ $t("All activities") }}</option>
                    <option v-for="activity in auditLogsHelper.activities" :key="category.id" :value="activity.id"> {{ $t(activity.name) }}</option>
                    </select>-->
                <label class="text-bold">{{ $t("N. of rows") }}</label>
                <select class="bg-white select text-small" v-model.number="filters.limit">
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                </select>
            </div>
            <div class="filter-left">
                <label class="text-bold">{{ $t("From") }}</label>
                <input type="date" class="date select text-small" v-model="filters.dt_inf" min="2025-01-01" :max="Date.now() | moment('YYYY-MM-DD')">
            </div>
            <div class="filter-left">
                <label class="text-bold">{{ $t("To") }}</label>
                <input type="date" class="date select text-small" v-model="filters.dt_sup" min="2025-01-01" :max="Date.now() | moment('YYYY-MM-DD')">
            </div>
            <div class="filter-left d-flex flex-align-end">
                <button @click="applyFilters" class="button secondary">{{ $t("Filter") }} </button>
            </div>
        </div>
        <!--RISULTATI-->
        <div class="results-section">
            <!--------------------------CONTENUTO PAGINA----------------------------------->
            <div v-if="auditLogs == null" class="d-flex flex-justify-center p-10">
                <span class="mif-spinner2 fg-primary ani-spin mif-3x" />
            </div>
            <!--FINE FILTRI E RICERCA-->
            <NoDataAvailable v-else-if="auditLogs.length == 0" :message="$t('No audit log available')" />
            <table v-else class="table striped row-hover row-border table-border compact responsive-md m-0 bg-white">
                <thead>
                    <tr>
                        <th class="">{{ $t("Date") }}</th>
                        <th class="">{{ $t("User") }}</th>
                        <th class="">{{ $t("Activity") }}</th>
                        <th class="">{{ $t("Details") }}</th>
                        <th class="">{{ $t("IP Address") }}</th>
                        <th>User-Agent</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="auditLog in auditLogs" :key="auditLog.id_log">
                        <td class="">
                            {{ auditLog.dt_log.toLocalDate() }}
                        </td>
                        <td class="">
                            {{ auditLog.username }}
                        </td>
                        <td>
                            <div class="">{{ $t(auditLog.activity) }}</div>
                            <div>{{ $t(auditLog.category) }}</div>
                        </td>
                        <td :title="$t(auditLog.details, auditLog.args)">
                            {{ $t(auditLog.details, auditLog.args) }}
                        </td>
                        <td class="">
                            {{ auditLog.ip_address }}
                        </td>
                        <td :title="auditLog.user_agent">
                            {{ auditLog.user_agent }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <!--<table v-else class="table border striped m-0 bg-white">
                <thead>
                    <tr>
                        <th class=" ">{{ $t("Date") }}</th>
                        <th class=" ">{{ $t("User") }}</th>
                        <th class=" ">{{ $t("Activity") }} - {{ $t("Category") }}</th>
                        <th class=" ">{{ $t("Details") }}</th>
                        <th class=" ">{{ $t("IP Address") }}</th>
                        <th style="max-width: 400px;">User-Agent</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="auditLog in auditLogs" v-bind:key="auditLogs.id_log">
                        <td class=" ">
                            {{ auditLog.dt_log.toLocalDate() }}
                        </td>
                        <td class=" ">
                            {{ auditLog.username }}
                        </td>
                        <td class=" ">
                            {{$t(auditLog.activity) }} - {{ $t(auditLog.category) }}
                        </td>
                        <td class=" ">
                            {{ $t(auditLog.details, auditLog.args) }}
                        </td>
                        <td class=" ">
                            {{ auditLog.ip_address }}
                        </td>
                        <td style="max-width: 400px;" class="text-truncate" :title="auditLog.user_agent">
                            {{ auditLog.user_agent }}
                        </td>
                    </tr>
                </tbody>
            </table>-->
            <div v-if="auditLogs && auditLogs.length != 0" class="d-flex flex-justify-between">
                <label class="p-2">{{ $t("{0} results · Page {1}", { 1: filters.index + 1, 0: Object.keys(auditLogs).length }) }} </label>
                <div class="row pr-2 pl-0">
                    <div class="col-auto ">
                        <button class="button secondary" @click="filters.offset = (filters.index -= 1) * filters.limit; applyFilters()" :disabled="filters.offset == 0"><span class="mif-arrow-left mr-2"></span>{{ $t("Back") }}</button>
                    </div>
                    <!--<div class="col-auto ">
                        <button class="button secondary" @click="filters.offset = (filters.index = 0) * filters.limit; applyFilters()" :disabled="filters.offset == 0" >{{ $t("First Page") }}</button>
                        </div>-->
                    <div class="col-auto ">
                        <button class="button secondary" @click=" filters.offset = (filters.index += 1) * filters.limit; applyFilters()" :disabled="!has_more">{{ $t("Next") }}<span class="mif-arrow-right ml-2"></span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { AuditLogsHelper } from '../utils/objects';
import Navigation from './utils/Navigation.vue';
import NoDataAvailable from './utils/NoDataAvailable.vue';

export default {
   name: "AuditLogs",
   components: {
      Navigation,
      NoDataAvailable
   },
   data() {
      return {
         auditLogs: null,
         auditLogsHelper: AuditLogsHelper,
         filters: {
            has_more: false,
            category: "",
            /*id_activity: "",*/
            user: "",
            dt_inf: this.$moment().subtract(3, 'days').format('YYYY-MM-DD'),
            dt_sup: this.$moment().format('YYYY-MM-DD'),
            limit: 25,
            offset: 0,
            index: 0
         },
         categories: null,
         users: null
      }
   },
   created() {
      this.users=this.$session.getUsers();
      this.applyFilters();
   },
   methods: {
      applyFilters() {

         this.$api.getAuditLogs(this.filters).then(res => {
            this.has_more=res.has_more;

            if (this.auditLogs==null) {
               this.auditLogs=res.logs;
            } else {
               this.auditLogs.update(res.logs);
            }
         });

         this.$api.getAuditCategories().then((res) => {
            this.categories=res;
         });

      },
      /*replaceArgs(log) {

         var map_id_name={};

         for (var [argName, id] of Object.entries(log.args)) {
            if (!map_id_name[id]) {

               switch (argName) {
                  case "ID_USER": // in sessione
                     map_id_name[id]=this.users.find(u => u.id==id).username;
                     break;
                  case "ID_GROUP": // in sessione
                     map_id_name[id]=this.$session.getGroupWithID(id).name_group;
                     break;
                  case "ID_COMPUTER": // in sessione
                     map_id_name[id]=this.$session.getPCWithID(id).pc_name;
                     break;

                  case "ID_JOB": //TODO
                     break;
                  case "ID_POLICY": // in sessione
                     map_id_name[id]=this.$session.getPolicyWithID(id).name;
                     break;
                  case "ID_SERVICE_ACCOUNT": // in sessione
                     map_id_name[id]=this.$session.getServiceAccountWithID(id).name;
                     break;
                  case "ID_REPOSITORY": //in sessione
                     map_id_name[id]=this.$session.getRepositoryWithID(id).name;
                     break;
               }
            }
            log.args[argName]=map_id_name[id];
         }
         return log;
      }*/
   }
}
</script>
